var brand = window.location.href;
var ha_numbers, brand_name, ha_btn_number;
if(brand.includes("signia")){ ha_numbers=7; ha_btn_number=11;  brand_name="signia";}
else if(brand.includes("phonak")){ ha_numbers=4; ha_btn_number=5;  brand_name="phonak"; }
else if(brand.includes("widex")){ ha_numbers=4; ha_btn_number=5;  brand_name="widex"; }
else if(brand.includes("resound")){ ha_numbers=4; ha_btn_number=5;  brand_name="resound"; }
else if(brand.includes("starkey")){ ha_numbers=4; ha_btn_number=5;  brand_name="starkey"; }
else { ha_numbers=4; ha_btn_number=5;  brand_name="oticon"; }

/////scroll section
const wid = window.innerWidth;
const element = document.getElementById("scroll_elements");
const btns = document.getElementById("scroll_btns");

function make_btn_active(x){
  for (var i =1 ; i<ha_btn_number ; i++){
    if (i==x) { document.getElementById("scroll_btn"+i).className="scroll_btn_active"; }
    else { document.getElementById("scroll_btn"+i).className="scroll_btn"; }
  }
}


scroller();

var allButtons = document.querySelectorAll('.scroll_btn_sel');
allButtons.forEach(function(button, index) {
  button.addEventListener('click', function() {
    setTimeout(function () {
     element.scrollLeft = (window.innerWidth)*index;  make_btn_active(index+1);
    }, 500);
  });
});


window.addEventListener("resize", function () {
    scroller();
});
  
function scroller(){
  if(window.innerWidth>=element.scrollWidth){ btns.style.display="none" }
  else {
      element.style.justifyContent="flex-start";
      btns.style.display="flex";
      var num_btns_show = element.scrollWidth/window.innerWidth;
      num_btns_show = Math.ceil(num_btns_show)+1;
      for (var n =num_btns_show ; n<ha_btn_number ; n++){
        document.getElementById("scroll_btn"+n).style.display="none";
      }
      for (var f =1 ; f<num_btns_show ; f++){
        document.getElementById("scroll_btn"+f).style.display="flex";
      }
  }
}

$('#scroll_elements').scroll(function() {
  var sc_w = element.scrollWidth;
  var sc = element.scrollLeft;
  var sc_max = element.scrollWidth - element.clientWidth;
  var wi = window.innerWidth;
  var wi_2 = Math.floor(wi*75/100);
  var num_btns_show = sc_w/wi;
  num_btns_show = Math.ceil(num_btns_show);
  if(wi<sc_w){
    if ( sc==0 ) { make_btn_active(1); }
    else if ( sc==sc_max ) { make_btn_active(num_btns_show);  }
    else {
      var ss= Math.ceil(sc/wi_2);
      make_btn_active(ss);
    }
  }
});


////review
const review_main = document.getElementById("bth_main_review");
const bth_review_1 = document.getElementById("bth_review1");
const bth_review_2 = document.getElementById("bth_review2");
const bth_review_3 = document.getElementById("bth_review3");
const bth_review_4 = document.getElementById("bth_review4");
const bth_review_5 = document.getElementById("bth_review5");
const review_btn1 = document.getElementById("bth_review1_btn");
const review_btn2 = document.getElementById("bth_review2_btn");
const review_btn3 = document.getElementById("bth_review3_btn");
const review_btn4 = document.getElementById("bth_review4_btn");
const review_btn5 = document.getElementById("bth_review5_btn");

const img_arr_left = document.getElementById("img_arr_left");
const img_arr_right = document.getElementById("img_arr_right");


function rev_btn1() {
   review_btn1.className="scroll_btn_active"; review_btn2.className="scroll_btn_gr"; review_btn3.className="scroll_btn_gr"; review_btn4.className="scroll_btn_gr"; review_btn5.className="scroll_btn_gr";            
}
function rev_btn2() {
   review_btn1.className="scroll_btn_gr"; review_btn2.className="scroll_btn_active"; review_btn3.className="scroll_btn_gr"; review_btn4.className="scroll_btn_gr"; review_btn5.className="scroll_btn_gr";            
}
function rev_btn3() {
   review_btn1.className="scroll_btn_gr"; review_btn2.className="scroll_btn_gr"; review_btn3.className="scroll_btn_active"; review_btn4.className="scroll_btn_gr"; review_btn5.className="scroll_btn_gr";            
}
function rev_btn4() {
   review_btn1.className="scroll_btn_gr"; review_btn2.className="scroll_btn_gr"; review_btn3.className="scroll_btn_gr"; review_btn4.className="scroll_btn_active"; review_btn5.className="scroll_btn_gr";            
}
function rev_btn5() {
   review_btn1.className="scroll_btn_gr"; review_btn2.className="scroll_btn_gr"; review_btn3.className="scroll_btn_gr"; review_btn4.className="scroll_btn_gr"; review_btn5.className="scroll_btn_active";            
}

review_btn1.onclick = function() { 
  review_main.style.animation="animatehidel 1s";
  setTimeout(function () { 
    review_main.innerHTML = bth_review_1.innerHTML; rev_btn1();
    review_main.style.animation="animateshowl 1s";
  }, 500);
}
review_btn2.onclick = function() { 
  review_main.style.animation="animatehidel 1s";
  setTimeout(function () { 
    review_main.innerHTML = bth_review_2.innerHTML;  rev_btn2(); 
    review_main.style.animation="animateshowl 1s";
  }, 500);
}
review_btn3.onclick = function() {
  review_main.style.animation="animatehidel 1s";
  setTimeout(function () { 
    review_main.innerHTML = bth_review_3.innerHTML; rev_btn3();
    review_main.style.animation="animateshowl 1s";
  }, 500);
}

review_btn4.onclick = function() { 
  review_main.style.animation="animatehidel 1s";
  setTimeout(function () { 
    review_main.innerHTML = bth_review_4.innerHTML; rev_btn4();  
    review_main.style.animation="animateshowl 1s";
  }, 500);
}
review_btn5.onclick = function() { 
  review_main.style.animation="animatehidel 1s";
  setTimeout(function () { 
    review_main.innerHTML = bth_review_5.innerHTML; rev_btn5();
    review_main.style.animation="animateshowl 1s";
  }, 500);
}

var count_rev =1;

img_arr_left.onclick = function() {
  if (count_rev==1){ count_rev=5;}
  else {count_rev--;}
  review_main.style.animation="animatehidel 1s";
  setTimeout(function () {
    review_main.innerHTML = document.getElementById("bth_review"+count_rev).innerHTML;
    switch(count_rev){
      case 1: rev_btn1(); break;
      case 2: rev_btn2(); break;
      case 3: rev_btn3(); break;
      case 4: rev_btn4(); break;
      case 5: rev_btn5(); break;
    } 
    review_main.style.animation="animateshowl 1s";
  }, 500);
}

img_arr_right.onclick = function() {
  if (count_rev==5){ count_rev=1;}
  else {count_rev++;}
  review_main.style.animation="animatehider 1s";
  setTimeout(function () {
    review_main.innerHTML = document.getElementById("bth_review"+count_rev).innerHTML;
    switch(count_rev){
      case 1: rev_btn1(); break;
      case 2: rev_btn2(); break;
      case 3: rev_btn3(); break;
      case 4: rev_btn4(); break;
      case 5: rev_btn5(); break;
    } 
    review_main.style.animation="animateshowr 1s";
  }, 500);
  
}

////compare section
var compr_1_count=1, compr_2_count=2;
var left_b=1, right_b=2;
const compr_1_img =document.getElementById("compr_1_img");
const compr_1_underimg =document.getElementById("compr_1_underimg");
const compr_2_img =document.getElementById("compr_2_img");
const compr_2_underimg =document.getElementById("compr_2_underimg");

window.onload = function() {
    compr_1.addEventListener('swiped-left', function(e) {
        ll_btn_compr1();
    });
    compr_1.addEventListener('swiped-right', function(e) {
        rr_btn_compr1();
    });

    compr_2.addEventListener('swiped-left', function(e) {
        ll_btn_compr2();
    });
    compr_2.addEventListener('swiped-right', function(e) {
      rr_btn_compr2();
    });

    //review
    review_main.addEventListener('swiped-left', function(e) {
        if (count_rev==5){ count_rev=1;}
        else {count_rev++;}
        review_main.style.animation="animatehidel 1s";
        setTimeout(function () {
          review_main.innerHTML = document.getElementById("bth_review"+count_rev).innerHTML;
          switch(count_rev){
            case 1: rev_btn1(); break;
            case 2: rev_btn2(); break;
            case 3: rev_btn3(); break;
            case 4: rev_btn4(); break;
            case 5: rev_btn5(); break;
          } 
          review_main.style.animation="animateshowl 1s";
        }, 500);
    });
    review_main.addEventListener('swiped-right', function(e) {
        if (count_rev==1){ count_rev=5;}
        else {count_rev--;}
        review_main.style.animation="animatehider 1s";
        setTimeout(function () {
          review_main.innerHTML = document.getElementById("bth_review"+count_rev).innerHTML;
          switch(count_rev){
            case 1: rev_btn1(); break;
            case 2: rev_btn2(); break;
            case 3: rev_btn3(); break;
            case 4: rev_btn4(); break;
            case 5: rev_btn5(); break;
          } 
          review_main.style.animation="animateshowr 1s";
        }, 500);
    });
  
}			

function l_btn(){
  if (left_b==ha_numbers){ left_b=1;}  else {left_b++;}
  compr_1_img.style.animation="animatehidel60 1s"; compr_1_underimg.style.animation="animatehidel60 1s";
  setTimeout(function () {
    compr_1_img.innerHTML = document.getElementById("bfr_compr_a"+left_b+"_img").innerHTML;
    compr_1_underimg.innerHTML = document.getElementById("bfr_compr_a"+left_b+"_underimg").innerHTML;
    compr_1_img.style.animation="animateshowl60 1s"; compr_1_underimg.style.animation="animateshowl60 1s";
  }, 500);
  compr_1_count = left_b;
}
function r_btn(){
  if (right_b==ha_numbers){ right_b=1;}  else {right_b++;} 
  compr_2_img.style.animation="animatehider60 1s"; compr_2_underimg.style.animation="animatehider60 1s";
  setTimeout(function () {
    compr_2_img.innerHTML = document.getElementById("bfr_compr_a"+right_b+"_img").innerHTML;
    compr_2_underimg.innerHTML = document.getElementById("bfr_compr_a"+right_b+"_underimg").innerHTML;
    compr_2_img.style.animation="animateshowr60 1s"; compr_2_underimg.style.animation="animateshowr60 1s";
  }, 500);
  compr_2_count = right_b;
}

function ll_btn_compr1() {
  if (compr_1_count==ha_numbers){ compr_1_count=1;}
  else {compr_1_count++;}
  compr_1_img.style.animation="animatehidel60 1s"; compr_1_underimg.style.animation="animatehidel60 1s";
  setTimeout(function () {
    compr_1_img.innerHTML = document.getElementById("bfr_compr_a"+compr_1_count+"_img").innerHTML;
    compr_1_underimg.innerHTML = document.getElementById("bfr_compr_a"+compr_1_count+"_underimg").innerHTML;
    compr_1_img.style.animation="animateshowl60 1s"; compr_1_underimg.style.animation="animateshowl60 1s";
  }, 500);
  left_b = compr_1_count;
}

function rr_btn_compr1() {
  if (compr_1_count==1){ compr_1_count=ha_numbers;}
  else {compr_1_count--;}
  compr_1_img.style.animation="animatehider60 1s"; compr_1_underimg.style.animation="animatehider60 1s";
  setTimeout(function () {
    compr_1_img.innerHTML = document.getElementById("bfr_compr_a"+compr_1_count+"_img").innerHTML;
    compr_1_underimg.innerHTML = document.getElementById("bfr_compr_a"+compr_1_count+"_underimg").innerHTML;
    compr_1_img.style.animation="animateshowr60 1s"; compr_1_underimg.style.animation="animateshowr60 1s";
  }, 500);
  left_b = compr_1_count;
}

function ll_btn_compr2() {
  if (compr_2_count==ha_numbers){ compr_2_count=1;}
  else {compr_2_count++;}
  compr_2_img.style.animation="animatehidel60 1s"; compr_2_underimg.style.animation="animatehidel60 1s";
  setTimeout(function () {
    compr_2_img.innerHTML = document.getElementById("bfr_compr_a"+compr_2_count+"_img").innerHTML;
    compr_2_underimg.innerHTML = document.getElementById("bfr_compr_a"+compr_2_count+"_underimg").innerHTML;
    compr_2_img.style.animation="animateshowl60 1s"; compr_2_underimg.style.animation="animateshowl60 1s";
  }, 500);
  right_b = compr_2_count;
}

function rr_btn_compr2() {
  if (compr_2_count==1){ compr_2_count=ha_numbers;}
  else {compr_2_count--;}
  compr_2_img.style.animation="animatehider60 1s"; compr_2_underimg.style.animation="animatehider60 1s";
  setTimeout(function () {
    compr_2_img.innerHTML = document.getElementById("bfr_compr_a"+compr_2_count+"_img").innerHTML;
    compr_2_underimg.innerHTML = document.getElementById("bfr_compr_a"+compr_2_count+"_underimg").innerHTML;
    compr_2_img.style.animation="animateshowr60 1s"; compr_2_underimg.style.animation="animateshowr60 1s";
  }, 500);
  right_b = compr_2_count;
}
/////
$(document).ready(function(){
  $("#bfifth_dropd1").click(function(){
      $("#chevron_rotate1").toggleClass("chevron_rotate_down");
      $("#bfifth_dropd_hid1").slideToggle();
      $("#bfifth_dropd1_br1").toggle(); 
      $("#bfifth_dropd1_br2").toggle();
  });
  $("#bfifth_dropd2").click(function(){
      $("#chevron_rotate2").toggleClass("chevron_rotate_down");
      $("#bfifth_dropd_hid2").slideToggle();
  });
  $("#bfifth_dropd3").click(function(){
      $("#chevron_rotate3").toggleClass("chevron_rotate_down");
      $("#bfifth_dropd_hid3").slideToggle();
  });
  $("#bfifth_dropd4").click(function(){
      $("#chevron_rotate4").toggleClass("chevron_rotate_down");
      $("#bfifth_dropd_hid4").slideToggle();
  });
  $("#bfifth_dropd5").click(function(){
      $("#chevron_rotate5").toggleClass("chevron_rotate_down");
      $("#bfifth_dropd_hid5").slideToggle();
  });
});

$.ajax({
   type : "GET", 
   url : "https://storage.googleapis.com/trustville-widgets/shop/c/3384/prod/widget_json_feedbacks.json", 
   success : function(res) { 
       let result = JSON.parse(res);
       document.getElementById("rating_count_br").innerHTML = String(result.rating_count);
       document.getElementById("rating_average_br").innerHTML = String(result.rating_average);
   }, 
   error : function(res) { 
   } 
});


function add_block(feedbacks){
  feedbacks.forEach(function(feedback, index) {
    var ii = index+1;
    var node = document.getElementById("bth_review"+ii);
    var feedbackdate = new Date(feedback.date);
    var month = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"][feedbackdate.getMonth()];
    var lastdate = month + ' ' + feedbackdate.getDate() + ', '+ feedbackdate.getFullYear();
    node.innerHTML = '<span class="bsec_body_ele_txt_name translate" style="font-size: 22px; color: #1C1B1B;">'+feedback.rate+'/5</span>'+
     '<span class="bfirst_2sec_2sp2 translate" style="font-size: 18px; margin-top: -15px;">'+lastdate+'</span>'+
     '<span class="bsec_title translate" style="font-size: 32px; text-transform: capitalize;">'+feedback.feedback+'</span>'+
     '<span class="bfirst_2sec_2sp2 translate" style="font-size: 18px;">Customer review by '+feedback.name+
        ' from '+feedback.country+' on '+feedback.brand+' '+feedback.product+'</span>';
    if (index==0){
     review_main.innerHTML = '<span class="bsec_body_ele_txt_name translate" style="font-size: 22px; color: #1C1B1B;">'+feedback.rate+'/5</span>'+
     '<span class="bfirst_2sec_2sp2 translate" style="font-size: 18px; margin-top: -15px;">'+lastdate+'</span>'+
     '<span class="bsec_title translate" style="font-size: 32px; text-transform: capitalize;">'+feedback.feedback+'</span>'+
     '<span class="bfirst_2sec_2sp2 translate" style="font-size: 18px;">Customer review by '+feedback.name+
        ' from '+feedback.country+' on '+feedback.brand+' '+feedback.product+'</span>';
   }
  });
}




$.ajax({
         type : "GET", 
         url : "https://cdn.shopify.com/s/files/1/0511/3174/4427/files/Rev_Customers.json?v=1679314101",
         success : function(res) { 
            let result = JSON.parse(JSON.stringify(res));
            var new_feedbacks =[];
            switch(brand_name){
              case "signia":
                for (var i=1 ; i<Object.keys(result).length+1 ; i++){
                 if(result[i].rate >=4 && result[i].feedback.length > 25 && result[i].feedback.length <= 120 && result[i].feedback.length <= 180 && result[i].brand == "Signia" && result[i].product != "NA" && result[i].country != "NA")
                   new_feedbacks.push(result[i]);
                }
                break;
                
              case "phonak":
                for (var i=1 ; i<Object.keys(result).length+1 ; i++){
                 if(result[i].rate >=4 && result[i].feedback.length > 25 && result[i].feedback.length <= 120 && result[i].feedback.length <= 180 && result[i].brand == "Phonak" && result[i].product != "NA" && result[i].country != "NA")
                   new_feedbacks.push(result[i]);
                }
                break;

              case "widex":
                for (var i=1 ; i<Object.keys(result).length+1 ; i++){
                 if(result[i].rate >=4 && result[i].feedback.length > 25 && result[i].feedback.length <= 120 && result[i].feedback.length <= 180 && result[i].brand == "Widex" && result[i].product != "NA" && result[i].country != "NA")
                   new_feedbacks.push(result[i]);
                }
                break;

              case "resound":
                for (var i=1 ; i<Object.keys(result).length+1 ; i++){
                 if(result[i].rate >=4 && result[i].feedback.length > 25 && result[i].feedback.length <= 120 && result[i].feedback.length <= 180 && result[i].brand == "Resound" && result[i].product != "NA" && result[i].country != "NA")
                   new_feedbacks.push(result[i]);
                }
                break;

              case "starkey":
                for (var i=1 ; i<Object.keys(result).length+1 ; i++){
                 if(result[i].rate >=4 && result[i].feedback.length > 25 && result[i].feedback.length <= 120 && result[i].feedback.length <= 180 && result[i].brand == "Starkey" && result[i].product != "NA" && result[i].country != "NA")
                   new_feedbacks.push(result[i]);
                }
                break;

              case "oticon":
                for (var i=1 ; i<Object.keys(result).length+1 ; i++){
                 if(result[i].rate >=4 && result[i].feedback.length > 25 && result[i].feedback.length <= 120 && result[i].feedback.length <= 180 && result[i].brand == "Oticon" && result[i].product != "NA" && result[i].country != "NA")
                   new_feedbacks.push(result[i]);
                }
                break;
            }
           
            if(new_feedbacks.length <5){
              for (var i=1 ; i<Object.keys(result).length+1 ; i++){
                 if(result[i].rate >=4 && result[i].feedback.length > 25 && result[i].feedback.length <= 120 && result[i].product != "NA" && result[i].country != "NA")
                   new_feedbacks.push(result[i]);
                }
              new_feedbacks = [...new Set(new_feedbacks)];
            }

            add_block(new_feedbacks);
         }, 
         error : function(res) { 
         } 
});